<template>
  <div class="lbox">
    <div class="banbox">
      <!-- <div style="height:20px;width: 100%;z-index: 999; background-color: #fff;position: absolute;"> -->

      <!-- <span style="margin-left: 10px;">{{getformRoute()}}</span> -->
      <!-- </div> -->
      <div class="banner">
        <!-- <div class="bannerCon">{{ routeData.name }}</div> -->

        <div
          class="carousel-inner"
          :style="{ transform: 'translateX(' + -100 * currentIndex + '%)' }"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
          @touchend="onTouchEnd"
        >
          <div v-for="(item, index) in routeData.bannerImg" :key="index" class="carousel-item">
            <video-player
              v-if="item.url.indexOf('.mp4') !== -1"
              class="vjs-custom-skin"
              ref="videoPlayer"
              :options="item.playerOptions"
              :playsinline="true"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @loadeddata="onPlayerLoadeddata($event)"
              @waiting="onPlayerWaiting($event)"
              @playing="onPlayerPlaying($event)"
              @timeupdate="onPlayerTimeupdate($event)"
              @canplay="onPlayerCanplay($event)"
              @canplaythrough="onPlayerCanplaythrough($event)"
              @ready="playerReadied"
              @statechanged="playerStateChanged($event)"
            >
            </video-player>

            <img :src="item.url" v-else class="langImg" />
            <p>{{ item.text }}</p>
          </div>
        </div>
        <button @click="previous" class="leftBtn pubbtn"></button>
        <button @click="next" class="rightBtn pubbtn"></button>
        <div class="carousel-indicators" v-if="showItems">
          <span
            v-for="(item, index) in routeData.bannerImg"
            :key="index"
            :class="{ 'indicator-active': index === currentIndex }"
            @click="currentIndex = index"
          ></span>
        </div>
        <div class="uploadWrap"         v-if="getRoute() == 'courseEdit'">
          <el-button size="small" type="success" style="color: #fff" @click="uploadDialog = true"
            >点击上传</el-button
          >
        </div>
      </div>
    </div>

    <v-dialog v-model="uploadDialog" max-width="800px"  persistent>
      <v-card class="card-shadow border-radius-xl">
        <v-card-text class="card-padding">
          <v-select
            v-model="form.type"
            :items="zyTypeList"
            item-text="name"
            color="#4caf50"
            item-value="type"
            label="类型 *"
            no-data-text="暂无数据"
            :rules="[v => !!v || '类型不能为空']"
            @change="clear"
            class="mediumType"
          ></v-select>
          <v-file-input
            v-if="form.type == 'img'"
            truncate-length="15"
            color="#4caf50"
            label="封面图片上传"
            @change="f => (form.preImg = fileChange(f))"
            :value="form.preImg"
            accept="image/*"
            show-size
            multiple
          ></v-file-input>
          <v-file-input
            v-if="form.type == 'video'"
            truncate-length="15"
            color="#4caf50"
            label="视频预览图上传"
            @change="f => (form.videoPreImg = fileChange(f))"
            :value="form.preImg"
            accept="image/*"
            show-size
          ></v-file-input>
          <v-file-input
            v-if="form.type == 'video'"
            @change="f => (form.preVideo = fileChange(f))"
            label="视频上传"
            :value="form.preVideo"
            accept="video/*" 
            chips
            multiple
          ></v-file-input>
          <v-card-actions class="card-padding d-flex justify-end">
            <v-btn
              elevation="0"
              :ripple="false"
              height="35"
              color="success"
              class="font-weight-normal text-capitalize btn-ls py-3 px-6"
              @click="save"
              :loading="btnloading"
              >{{this.btnloading==true?'上传中':'保存'}}</v-btn
            >
            <v-btn
              elevation="0"
              :ripple="false"
              height="35"
              class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
              @click="close"
              >取消</v-btn
            >
          </v-card-actions>

          <!-- 
            <el-upload
           v-if="getRoute() == 'courseEdit'"
            :show-file-list="false"
            action=""
            :file-list="routeData.bannerImg"
            class="upload-demo"
            list-type="text"
            :http-request="params => httpRequest(params, 'courseDetail')"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'courseDetail')"
            multiple
          >
            <el-button size="small" type="success" style="color: red">点击上传</el-button>
          </el-upload> -->
        </v-card-text>
      </v-card>
    </v-dialog>

    <div :class="this.isMobile.isMobile? this.routeData.bannerImg&&this.routeData.bannerImg.length>4?'bannerSmall bannerSmall70 ':'bannerSmall bannerSmall40':'bannerSmall thumbnailWrap'" >
      <!-- <div
        v-for="(item, index) in routeData.bannerImg"
        :key="index"
        class="thumbnail"
        :class="{ 'thumbnail-active': index === currentIndex }"
        @click.stop="changeSlide(index)"
        :style="{ transform: `translateX(${100 * index}%)`, width: `${100 / showImgNum}%` }"
      >
        <span
          v-if="getRoute() == 'courseEdit'"
          @click.stop="deleteImg(item)"
          class="iconfont icon-shanchutianchong deletebtn"
        ></span>
        <video
          v-if="item.url.indexOf('.mp4') !== -1"
          :src="item.url"
          style="height: 100px; width: 100%"
          @click.prevent
          :autoplay="false"
          stop
          :poster="item.poster"
        ></video>
        <img :src="item.url" v-else style="height: 100px; width: 100%" />
      </div> -->
      <draggable v-model="routeData.bannerImg" item-key="id"  :class="maxFour()"    handle=".thisDrag"  :disabled="getRoute() == 'courseEdit'?false:true" >
        <div
        v-for="(item, index) in routeData.bannerImg"
        :key="index"
        class="thumbnail"
        :class="{ 'thumbnail-active': index === currentIndex }"
        @click.stop="changeSlide(index)"
        :style="{  width: '24%' }"
          
      >
        <span
          v-if="getRoute() == 'courseEdit'"
          @touchstart.prevent="deleteImg(item)"
          @click.stop="deleteImg(item)"
          class="iconfont icon-shanchutianchong deletebtn thisDrag"
        ></span>
        <video
        class="thisDrag video-poster"
          v-if="item.url.indexOf('.mp4') !== -1"
          :src="item.url"
          style="height: 100px; width: 100%"
          @click.prevent
          :autoplay="false"
          stop
          :poster="item.poster"
        ></video>
        <img :src="item.url" v-else style="height: 100px; width: 100%" />
      </div>
    </draggable>
    </div>
  </div>
</template>
  <script>
import { getdetailList, queryCourseThree, resetSimulation } from '@/api/simulation';
import { mapGetters } from 'vuex';
import 'video.js/dist/video-js.css';
// import { Modal } from '../../../components/index';
//  import { openUriWithTimeoutHack } from "./monitoringApp";
import Swiper from 'swiper';
import moment from 'moment';
// import { openUriWithTimeoutHack } from './monitoringApp.js';
// import courseDetail from '../SimClassComponents/courseDetailWrap.vue';
import { getossUploadToken } from '@/api/user';
import Oss from 'ali-oss';
import draggable from 'vuedraggable';
import Swal from 'sweetalert2';
export default {
  props: {
    routeData: {
      type: Object,
      default: null,
    },
  },
  components: {
    draggable
    // Modal,
    // courseDetail,
  },
  watch: {
    routeData: {
      handler(news) {
        if (news) {
          // this.bannerImg = news.bannerImg
          // console.log(news.bannerImg)
          if (news.bannerImg.length <= 0) {
            let obj = {
              id: this.guid(),
              url: this.routeData.cover,
              type: 'cover',
            };
            this.routeData.bannerImg.push(obj);
          } else {
            this.checkScreenWidth();
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'course','isMobile']),

    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  data() {
    return {
      btnloading: false,
      zyTypeList: [
        {
          type: 'img',
          name: '图片',
          id: 1,
        },
        {
          type: 'video',
          name: '视频',
          id: 2,
        },
      ],
      form: {
        type: 'img',
        preImg: null, //图片
        videoPreImg: null, //视频预览图
        preVideo: null,
      },
      uploadDialog: false,
      //   routeData: {},
      courseRelated: [
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
        {
          img: require('../../../assets/img/bg9.jpg'),
          courseName: '防灾减灾与应急救援',
          school: '广西安全学院',
          study: '203423次学习',
        },
      ],
      showItems: false,
      fileList: [],
      showImgNum: 4,
      currentIndex: 0,
      tags: [],
      myswiper: null,
      number: 0,

      imgList: [
        // { imgUrl: require('/public/img/bg9.jpg') },
        // { imgUrl: require('/public/img/bg3.jpg') },
        // { imgUrl: require('/public/img/bg-pricing.jpg') },
        // { imgUrl: require('/public/img/bdz.png') },
      ], // 因为这是mock过来的，所以这里是空数组
      modalVisible: false,
      ifc: null,
      isStartDownload: false,
      isFocus: false,
      playerOptions: {},
      isLoading1: false,
      isLoading2: false,
      thisCoure: {},
      treeData: [],
      relatedTreeData: [],

      directory: [
        {
          id: 1,
          name: '内容目录',
          isCheck: true,
        },
        {
          id: 2,
          name: '相关课程',
          isCheck: false,
        },
      ],

      refer_list: [
        { value: 'bk', name: '本科' },
        { value: 'gz', name: '高职' },
        { value: 'zz', name: '中职' },
        { value: 'gj', name: '技师学院' },
        { value: 'jx', name: '技校' },
        { value: 'qy', name: '企业' },
      ],
      thumbsSwiper: null,

      tagAll: [
        {
          type: 'PC',
          url: '../../../w10.png',
          name: '打开Window版本',
        },
        {
          type: 'VR',
          url: '../../../vr.png',
          name: '打开VR版本',
        },
        {
          type: 'WebGL',
          url: '../../../webGL.png',
          name: '打开WebGL版本',
        },
        {
          type: 'Android',
          url: '../../../az.png',
          name: '打开安卓版本',
        },
        {
          type: 'ZSpace',
          url: '../../../zspace.png',
          name: '打开ZSpace',
        },
        {
          type: 'KMAX',
          url: '../../../km.png',
          name: '打开KMAX版本',
        },
        {
          type: 'standalone',
          url: '../../../dr.png',
          name: '单机模式',
        },
      ],
      tagAlls: [
        {
          label: 'PC',
          value: 'PC',
        },
        {
          label: 'VR',
          value: 'VR',
        },
        {
          label: 'WebGL',
          value: 'WebGL',
        },
        {
          label: '安卓',
          value: 'Android',
        },
        {
          label: 'ZSpace',
          value: 'ZSpace',
        },
        {
          label: 'KMAX',
          value: 'KMAX',
        },
        {
          label: '单机模式',
          value: 'standalone',
        },
      ],
    };
  },
  methods: {
    clear() {
      if (this.form.type == 'img') {
        this.form.videoPreImg = null;
        this.form.preVideo = null;
      } else {
        this.form.preImg = null;
      }
    },
    maxFour(){

      if(this.isMobile.isMobile){
       if(this.routeData.bannerImg&&this.routeData.bannerImg.length>4){
         return 'draggableWrap four68' 
       }else{
        return 'draggableWrap four40'
       }
      }else{
        return 'draggableWrap'
      }
      if(this.routeData.bannerImg.length>4){
      }
   
    },
    fileChange(e) {
      console.log({
        e,
        f: this.form,
      });
      return e;
    },
  async  save() {
      let _this = this;
      if (this.form.type == 'img') {
        //图片
        this.btnloading = true;

        const uploadPromises = [];
        for (let i = 0; i < this.form.preImg.length; i++) {
          const file = this.form.preImg[i];
          uploadPromises.push(this.uploadImage(file, 'preImg'));
        }
        Promise.all(uploadPromises)
          .then(addresses => {
            addresses.forEach(item => {
              let obj = {
                id: _this.guid(),
                url: item.url,
              };
              _this.routeData.bannerImg.push(obj);
            });
            _this.btnloading = false;
            _this.close()
          })
          .catch(error => {
            console.error('上传图片出错:', error);
            _this.close()
          });
        
      } else {
        //视频
        console.log(this.form.videoPreImg)
        if(!this.form.videoPreImg){
          this.$notify({
          timeout: 1500,
          message: '请上传视频预览图',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
        });
        return 

        }

        _this.btnloading = true;
        let  videoPreImg =  await this.uploadImage(this.form.videoPreImg,'videoPreImg')

        const uploadPromises = [];
        for (let i = 0; i < this.form.preVideo.length; i++) {
          const file = this.form.preVideo[i];
          uploadPromises.push(this.uploadImage(file, 'preVideo'));
        }
        Promise.all(uploadPromises)
          .then(addresses => {
            addresses.forEach(item => {
              let obj = {
                id: _this.guid(),
                url: item.url,
                playerOptions: {},
                poster:videoPreImg.url
              };
              obj.playerOptions = {
                // loop: false, // 导致视频一结束就重新开始。
                // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                  timeDivider: true,
                  durationDisplay: true,
                  remainingTimeDisplay: false,
                  fullscreenToggle: true, //全屏按钮
                },
                height: '350',
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                language: 'en', //zh-CN
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                sources: [
                  {
                    type: 'video/mp4',
                    // mp4
                    src: item.url,
                    // webm
                    // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                  },
                ],
                poster: videoPreImg.url, //你的封面地址
              };
              _this.routeData.bannerImg.push(obj);
            });
            _this.btnloading = false;
            _this.close()
          })
          .catch(error => {
            console.error('上传图片出错:', error);
            _this.close()
            _this.btnloading = false;
          });
      }
    },
    close() {
      this.uploadDialog = false;
      this.form.preImg = null;
      this.form.preVideo = null;
    },

    // 单个图片上传函数
    uploadImage(param, type) {
      return new Promise((resolve, reject) => {
        getossUploadToken({})
          .then(result => {
            const creditInfo = result.data;
            const aliOss = new Oss(creditInfo);
            aliOss
              .put(`${type}/${new Date().getTime()}/${param.name}`, param, {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                },
              })
              .then(res => {
                resolve(res);
              });
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },

    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
  async  deleteImg(item) {

      let result = await Swal.fire({
        title: '提示',
        text: `确认删除此张封面图？`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
      
        if (this.routeData.bannerImg.length == 1) {
        this.$notify({
          timeout: 1500,
          message: '至少保留一张图片',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
        });
        return;
      }
      this.routeData.bannerImg = this.routeData.bannerImg.filter(items => item.id !== items.id);
      this.currentIndex--;
      this.currentIndex =0

      return 
      }

    



      // if (item.type && item.type == 'cover') {
      //   this.$notify({
      //     timeout: 1500,
      //     message: '此张为课程封面，无法删除',
      //     horizontalAlign: 'center',
      //     verticalAlign: 'bottom',
      //     type: 'warning',
      //   });
      //   return;
      // }

 

    },
    onTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchCurrentX = this.touchStartX;
      this.touchDiffX = 0;
      this.isSwiping = true;
    },
    onTouchMove(event) {
      if (this.isSwiping) {
        this.touchCurrentX = event.touches[0].clientX;
        this.touchDiffX = this.touchCurrentX - this.touchStartX;
      }
    },
    onTouchEnd() {
      this.isSwiping = false;
      if (Math.abs(this.touchDiffX) > 50) {
        // 如果滑动距离超过50px，切换轮播图
        if (this.touchDiffX > 0) {
          this.previous();
        } else {
          this.next();
        }
      }
      this.touchDiffX = 0; // 重置滑动距离差值
    },
    next() {
      this.stopVideo();

      if (this.currentIndex < this.routeData.bannerImg.length - 1) {
        this.currentIndex++;
      }

      // if (this.currentIndex > 3) {
      //   let num = this.currentIndex;
      //   let thumbnailWrap = document.getElementsByClassName('thumbnailWrap')[0];
      //   if(thumbnailWrap){
      //     thumbnailWrap.style.transform = `translateX(-${(num - 3) * 25}%)`;
      //   }
      // }

      console.log(this.currentIndex, 'this.currentIndex');
    },
    stopVideo() {
      const player = this.$refs.videoPlayer;
      // const player = this.$refs.videoPlayer[0].player;
      if (player&&player.length > 0) {
        player.forEach(item => {
          item.player.pause();
        });
      }
    },
    previous() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
      console.log(this.currentIndex);
      // if (this.currentIndex <= 3) {
      //   let num = this.currentIndex;
      //   let thumbnailWrap = document.getElementsByClassName('thumbnailWrap')[0];
      //   if(thumbnailWrap){
      //     thumbnailWrap.style.transform = `translateX(0%)`;
      //   }

      // }
      this.stopVideo();
    },
    changeSlide(index) {
      this.stopVideo();
      this.currentIndex = index;
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getRoute() {
      // courseView //查看    courseEdit 编辑
      let route = null;
      if (this.$route.query && this.$route.query.courseType) {
        route = this.$route.query.courseType;
      }
      return route;
    },
    // getformRoute(){
    //     let str = null
    //     if(this.$route.query&&this.$route.query.type){
    //        if(this.$route.query.type=='simclass'){
    //          str = '首页>数字课堂'
    //        }
    //        if(this.$route.query.type=='home'){
    //           str = '首页/数字课堂'

    //        }
    //       // "simclass" //数字课堂
    //       //"dashboard"  //首页

    //     }
    //     return str;
    // },
    buttonNext() {
      this.number++;
      if (this.number > 3) {
        this.number = 0;
      }

      // this.number = this.number + 1;
      console.log(this.number);
      //       //这里因为一些原因我找不到它原来问题，但我解决了自己问题了，这里是六张一组缩列图，当第七张的时候缩列图就该切组
      // if (this.number == 6) {
      //      document.getElementById("myNext").click();
      // }
    },
    buttonPrev() {
      this.number--;
      if (this.number < 0) {
        this.number = 3;
      }

      // this.number = this.number - 1;
      console.log(this.number);
    },
    change(index) {
      this.number = index;
      console.log(index, this.number);
      console.log(this.mySwiper.activeIndex);

      // 切换到索引为 2 的幻灯片（即第三张）
      this.mySwiper.slideTo(this.number); // 第二个参数是可选的，表示过渡动画的持续时间
    },

    //分享
    shareToMicroblog(type) {
      //跳转地址
      let url = encodeURIComponent('http://meta-v4.icubespace.com/');
      let title = encodeURIComponent('元世界.自动化教学设计平台');
      switch (type) {
        case 'weixin':
          break;

        case 'weixinkongjian':
          this.getShareInfo();
          break;

        case 'qq':
          window.open(
            `https://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&source=${url}&desc=${title}&pics=`
          );
          break;

        case 'qqkongjian':
          window.open(
            `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${title}&summary=${title}&site=${url}`
          );
          break;

        case 'weibo':
          window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`);
          break;
      }
    },

    // vue调用微信的自定义分享
    getShareInfo() {},
    isrefer() {
      let str = '';
      this.refer_list.forEach(item => {
        if (this.thisCoure && this.thisCoure.refer) {
          if (item.value == this.thisCoure.refer[0]) {
            str = item.name;
          }
        }
      });
      return str;
    },

    //打开客户端
    async openClientDetail(platform = 'PC') {
      let item = this.routeData;
      // if (!['VR', 'PC'].includes(platform)) return;
      const params = encodeURIComponent(
        JSON.stringify({
          token: localStorage.getItem('token'),
          course: item.courseId ?? item.project.course,
          projectId: item.project ? item.project._id : '',
          version: item.version,
          platform,
          simulationId: item._id,
          runtime: process.env.VUE_APP_RUNTIME,
        })
      );
      if ('WebGL' === platform) {
        window.open(`http://meta.webgl.icubespace.com/WebGL/index.html?json=${params}`, '_blank');
        return;
      }
      this.ifr = document.createElement('iframe');
      this.ifr.src = `MetaSpaceProject://${params}`;
      this.ifr.style.display = 'none';
      document.body.append(this.ifr);
      const appUri = `MetaSpaceProject://${params}`; // 应用程序的地址(注册表应用名称)
      const timeoutDuration = 3000;
      const openAppFailure = () => {
        const url =
          'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/%E8%81%8C%E4%B8%9A%E6%95%99%E8%82%B2%E5%85%83%E4%B8%96%E7%95%8C%E5%AE%89%E8%A3%85%E8%BD%AF%E4%BB%B6V4.7.exe';
        const res = confirm('应用程序未安装,请下载并安装');
        if (res) {
          window.location.href = url; // window.open会被浏览器拦截,使用window.location.href下载exe
        }
      };
      const openAppSuccess = () => {
        console.log('成功打开本地应用程序');
      };

      openUriWithTimeoutHack(appUri, openAppFailure, openAppSuccess, timeoutDuration);
    },

    handleDownload() {
      this.modalVisible = false;
      location.href =
        'https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/temp/%E8%81%8C%E4%B8%9A%E6%95%99%E8%82%B2%E5%85%83%E4%B8%96%E7%95%8C%E5%AE%89%E8%A3%85%E8%BD%AF%E4%BB%B6V4.7.exe';
    },

    handleBlur() {
      this.isFocus = false;
      // console.log('失去焦点了')
    },

    //跳转页面

    onPlayerPlay(e) {},
    onPlayerPause(e) {},
    onPlayerEnded(e) {},
    onPlayerLoadeddata(e) {},
    onPlayerWaiting(e) {},
    onPlayerPlaying(e) {},
    onPlayerTimeupdate(e) {},
    onPlayerCanplay(e) {},
    onPlayerCanplaythrough(e) {},
    playerReadied(e) {},
    playerStateChanged(e) {},
    checkScreenWidth() {
  
      // 获取当前屏幕宽度
      const screenWidth = window.innerWidth;

      // 检查屏幕宽度是否小于 600px
      if (screenWidth < 600) {
        this.routeData.bannerImg.forEach(item => {
          if (item.playerOptions) {
            item.playerOptions.height = '155';
          }
        });
      } else {
        // console.log('屏幕宽度大于或等于 600px。');
      }
    },

    // async querydetailList() {
    //   if (this.$route.query._id) {
    //     let res = await getdetailList({ _id: this.$route.query._id });

    //     if (!res.data) return;
    //     this.routeData = res.data;
    //   }
    // },
  },

  mounted() {
    let _this = this;

    // this.querydetailList();

    let content = document.getElementsByClassName('content')[0];
    let header = document.getElementsByClassName('md-toolbar')[0].clientHeight;
    let footer = document.getElementsByClassName('footer')[0].clientHeight;
    let client = document.body.clientHeight - header - footer;
    content.style.cssText = `height:auto; min-height:${client}px;overflow-y:scoll`;
    if (this.$route.query.type && this.$route.query.type == 'home') {
      let timer = setTimeout(() => {
        let dashboardIdMenu = document.getElementById('dashboardIdMenu');
        if (dashboardIdMenu) {
          let dashboardIdMenu = document.getElementById('dashboardIdMenu');
          dashboardIdMenu.style.cssText =
            'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
          clearTimeout(timer);
        }
      }, 400);
    }

    if (this.$route.query.type && this.$route.query.type == 'simclass') {
      let timer = setTimeout(() => {
        let simclassIdMenu = document.getElementById('simclassIdMenu');
        if (simclassIdMenu) {
          let simclassIdMenu = document.getElementById('simclassIdMenu');
          simclassIdMenu.style.cssText =
            'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
          clearTimeout(timer);
        }
      }, 400);
    }
    // this.checkScreenWidth();
    window.addEventListener('resize', () => {
      this.checkScreenWidth();
    });
  },

  destroyed() {},
  created() {
    // this.getformRoute()
    this.getRoute();
    if (this.routeData) {
      console.log(this.routeData);
    }
  },
};
</script>
  
  
  <style>
@media (max-width: 599px) {
  .footer .container nav ul li > a {
    padding: 5px 10px;
  }
}
</style>
  <style  lang="scss" scoped>
.lbox {
  overflow: hidden;
  width: 60%;
  float: left;
  // overflow: hidden;
  .banbox {
    position: relative;
    width: 100%;
    // overflow: hidden;
    // float: left;
    border-radius: 3px;
    margin-bottom: 10px;
    .banner {
      height: 350px;
      width: 100%;
      background: #fff;
      position: relative;
      overflow: hidden;
      .uploadWrap {
        width: 50px;
        position: absolute;
        bottom: 2px;
        right: 33px;
      }
      .pubbtn {
        position: absolute;
        top: 50%;
        width: 35px;
        height: 50px;
        background-repeat: no-repeat;
        background-size: 100%;
      }
      .leftBtn {
        left: 0;
        background-image: url('../../../assets/img/leftbtn.png');
      }
      .rightBtn {
        right: 0;
        background-image: url('../../../assets/img/rightbtn.png');
        background-repeat: no-repeat;
      }
    }
  }

  .bannerSmall::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
  }

  /* 自定义滚动条样式（针对 Firefox 浏览器） */
  .bannerSmall {
    scrollbar-width: thin; /* 设置滚动条为细条 */
    scrollbar-color: #ccc #f5f5f5; /* 设置滚动条的颜色 */
  }

  .bannerSmall {
    -ms-overflow-style: none; /* 隐藏 IE 的默认滚动条 */
  }

  .bannerSmall::-ms-scrollbar {
    display: none; /* 隐藏 IE 的默认滚动条 */
  }
  .bannerSmall {
    // overflow: hidden;
    width: 100%;
    height: 120px;
    background: #d8d8d84f;
    position: relative;

    max-width: 755px; /* 最大宽度，根据需要设置 */
    // overflow-x: auto; /* 启用横向滚动条 */
    overflow-y: hidden; /* 启用横向滚动条 */
    // display: flex;
    // flex-wrap: nowrap;
    // overflow-x: scroll; /* 确保在内容超出时显示滚动条 */
    .thumbnail {
      // margin: 0 5px;
      margin-left: 0px;
      margin-right: 5px;
    }
    .thumbnail:first-child {
      margin: 0 5px 0 0;
    }
  }
}
.rbox {
  width: 38.5%;
  float: right;
  overflow: hidden;
  .card {
    font: 15px 'Microsoft YaHei', Arial, Helvetica, sans-serif;
    color: #333;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    box-shadow: 0px 1px 0px rgba(255, 255, 255, 0.1), inset 0px 1px 1px rgba(0, 0, 0, 0.7);
    border-radius: 3px;
    background: url('../../../assets/img/courseDetail.png') no-repeat top right rgba(42, 42, 42, 1);
    height: 350px;
    overflow: hidden;
    margin-bottom: 20px;
    .card h2 {
      font-size: 22px;
      margin: 10px;
      color: #89919a;
      font-weight: normal;
      padding-bottom: 10px;
    }
    .card p {
      font-size: 12px;
      padding: 0 0 0 20px;
      line-height: 28px;
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
      color: #d0d2d4;
      // -webkit-animation: animations2 5s ease-in-out 5s;
      // -moz-animation: animations2 5s ease-in-out 5s;
      // -o-animation: animations2 5s ease-in-out 5s;
      // -ms-animation: animations2 5s ease-in-out 5s;
      // animation: animations2 5s ease-in-out 5s;
    }
  }
}

.thumbnail {
  width: 100px; /* 缩略图的宽度 */
  height: 100px; /* 缩略图的高度 */
  cursor: pointer;
  transition: transform 0.3s;
  opacity: 0.5;
  // padding: 4px;
  // float: left;
  display: inline-block;
  background: #fff;
  position: relative;
  overflow: hidden;
}

.thumbnail-active {
  border: 1px solid #333;
  opacity: 1;
}

.thumbnail-image {
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: block;
}

.carousel {
  position: relative;
  max-width: 100%; /* 根据需要调整轮播图的最大宽度 */
  width: 100%;
  margin: auto;
  height: 350px;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  transition: transform 0.6s ease-in-out;
}

.carousel-item {
  min-width: 100%;
  transition: opacity 0.6s ease-in-out;
  height: 350px;
  position: relative;
  overflow: hidden;
}

.carousel-item img {
  width: 100%;
  height: 100%;
  display: block;
}

.langImg {
  width: 100%;
  height: 350px;
}
/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 600px) {
  
  .carousel-text {
    bottom: 10px;
    font-size: 14px;
  }

  .carousel {
    height: 230px !important;
  }

  .carousel-item {
    height: 155px !important;
  }

  .langImg {
    height: 155px !important;
  }
  .card {
    height: 155px !important;
  }
  .banner {
    height: 155px !important;
  }
  .deletebtn {
    font-size: 12px !important;
  }
  .lbox .bannerSmall{
  // height: 70px !important;
  // .draggableWrap{
  //   height: 40px !important;
  // }
  .thumbnail{
    height: 40px  !important;
    overflow: hidden;
    img{
      height: 40px  !important;
      width: 100%;
    }
    video{
      height: 40px  !important;
      width: 100%;
    }
//     .video-poster {
//   width: 100%;
//   height: auto;
// }

  }
}
}

ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.deletebtn {
  padding: 5px;
  position: absolute;
  right: 0px;
  top: 0px;
  background-color: rgb(255 255 255 / 39%);
  color: red;
  z-index: 99;
}

@media (max-width: 950px) {
  .wrap .lbox {
    width: 100% !important;
    margin-bottom: 20px;
  }

  // .wrap .rbox{
  //   width: 100% !important;
  //   float: none !important;
  // }
}

.btnItems {
  height: 100px !important;
  video-js {
    height: 100px !important;
  }
  video {
    height: 100px !important;
  }
}
>>> .btnItems >>> .video-js {
  height: 100px !important;
}

.btnItems >>> .video-js {
  height: 100px !important;
}

.bannerCon {
  position: absolute;
  right: 0px;
  top: 0px;
  background-color: rgb(76, 175, 80);
  z-index: 999;
  color: #fff;
  font-weight: bold;
  padding: 5px 10px;
}






.draggableWrap{
  // display: flex;
  // justify-content: space-between;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
  height: 120px;
}

.four68{
  height: 68px !important;
}
.four40{
  height: 40px !important;
}

  .bannerSmall70{
  height: 70px !important;

  }

  .bannerSmall40{
  height: 40px !important;
  }
</style>